module.exports = __webpack_public_path__ + "img/fig43.6639698d.jpg";